import { Component, OnInit, ViewContainerRef, Input } from '@angular/core';
import * as color from 'color';
import { TranslateService } from '@ngx-translate/core';
import { UUID } from 'angular2-uuid';
import * as _ from 'lodash';

@Component({
  selector: 'app-table-property',
  templateUrl: './table-property.component.html',
  styleUrls: ['./table-property.component.scss']
})
export class TablePropertyComponent implements OnInit {
  @Input() component: any;

  constructor(public vcRef: ViewContainerRef, private translate: TranslateService) { }

  ngOnInit() { 
    console.log(this.component)
  }

  setButtonStyle(style: string) {
    const c = color(this.component.element.button_color);

    switch (style) {
      case 'raised':
        this.component.element.box_shadow_color = c
          .darken(0.2)
          .hex()
          .toString();
        this.component.element.gradient_top_color = '';
        this.component.element.gradient_bottom_color = '';
        break;

      case 'gradient':
        this.component.element.box_shadow_color = '';
        this.component.element.gradient_top_color = c
          .lighten(0.2)
          .hex()
          .toString();
        this.component.element.gradient_bottom_color = c
          .darken(0.2)
          .hex()
          .toString();
        break;

      default:
        this.component.element.box_shadow_color = '';
        this.component.element.gradient_top_color = '';
        this.component.element.gradient_bottom_color = '';
        break;
    }
  }

  onColorPickerChange(color: any) {
    let buttonStyle = 'flat';
    if (this.component.element.box_shadow_color) {
      buttonStyle = 'raised';
    } else if (this.component.element.gradient_top_color) {
      buttonStyle = 'gradient';
    }

    this.setButtonStyle(buttonStyle);
  }

  setAsDefault($event: any) {
    this.component.element.options.forEach((v: any, k: number) => {
      if (v.id == $event.target.value) {
        v.is_selected = true;
      } else {
        v.is_selected = false;
      }
    });
  }

  addOption() {
    this.component.element.columns.push({
      id: UUID.UUID().split('-')[0],
      name: "col" + this.component.element.columns.length,
      valueType: 'text'
    });
  }

  removeOption(optionId: any) {
    this.component.element.columns = this.component.element.columns.filter((v: any) => {
      return v.id != optionId;
    });
  }

  addColumnDropDownOption(column: any) {
    if (column.options == null) column.options = [];
    column.options.push({})
  }

  // handleOnBindVariableChange($event: any) {
  //   this.onBindVariableChange.emit({
  //     value: $event,
  //     id: this.component.id
  //   });
  // }
}
